"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledProgressBar = exports.Progress = exports.Label = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

const StyledProgressBar = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  height: ", "px;\n  overflow: hidden;\n  width: 100%;\n  border: 1px solid ", ";\n  position: relative;\n  background-color: ", ";\n  ", ";\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.border.radius;
}, _ref2 => {
  let {
    height
  } = _ref2;
  return height || 20;
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.color.border.primary;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.color.background.primary;
}, _ref5 => {
  var _theme$components, _theme$components$pro;

  let {
    theme
  } = _ref5;
  return theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : (_theme$components$pro = _theme$components.progressbar) === null || _theme$components$pro === void 0 ? void 0 : _theme$components$pro.progressbar;
});

exports.StyledProgressBar = StyledProgressBar;

const Progress = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: 100%;\n  background-color: ", ";\n  width: ", "%;\n  ", ";\n"])), _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.color.background.secondary;
}, _ref7 => {
  let {
    progress
  } = _ref7;
  return progress;
}, _ref8 => {
  var _theme$components2, _theme$components2$pr;

  let {
    theme
  } = _ref8;
  return theme === null || theme === void 0 ? void 0 : (_theme$components2 = theme.components) === null || _theme$components2 === void 0 ? void 0 : (_theme$components2$pr = _theme$components2.progressbar) === null || _theme$components2$pr === void 0 ? void 0 : _theme$components2$pr.progress;
});

exports.Progress = Progress;

const Label = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  top: 0;\n  width: 100%;\n  position: absolute;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: ", ";\n  ", ";\n"])), _ref9 => {
  let {
    theme,
    progress
  } = _ref9;
  return progress > 40 ? theme.color.font.secondary : theme.color.font.primary;
}, _ref10 => {
  var _theme$components3, _theme$components3$pr;

  let {
    theme
  } = _ref10;
  return theme === null || theme === void 0 ? void 0 : (_theme$components3 = theme.components) === null || _theme$components3 === void 0 ? void 0 : (_theme$components3$pr = _theme$components3.progressbar) === null || _theme$components3$pr === void 0 ? void 0 : _theme$components3$pr.label;
});

exports.Label = Label;